import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { getBaseStylingProps } from '../BaseButton/style';
import useGetButtonElement from '../BaseButton/hooks/useGetButtonElement';
import { getStylingProps } from './style';
import type { TextButtonProps } from './types';

const TextButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, TextButtonProps>(
  (
    {
      intent = 'primary',
      size = 'md',
      variant = 'default',
      disabled,
      href,
      children,
      dataTrackTag = 'text_button',
      ...rest
    },
    ref
  ) => {
    const { element, role } = useGetButtonElement(href);
    const baseStylingProps = getBaseStylingProps(disabled, false);
    const stylingProps = getStylingProps(size, intent, variant, disabled);

    return (
      <Box
        {...baseStylingProps}
        {...stylingProps}
        {...rest}
        as={element}
        role={role}
        href={href}
        ref={ref}
        disabled={disabled}
        dataTrackTag={dataTrackTag}
      >
        {children}
      </Box>
    );
  }
);

TextButton.displayName = 'TextButton';

export default TextButton;
